import { collection, doc, setDoc } from "firebase/firestore";
import { Collections, PushNotificationLog, User } from "../types/type";
import { serverTimestamp } from "firebase/firestore";
import { db } from "../firebase/firebaseConfig";

export const extractYoutubeInfo = (
  youtubeLink: string
): { youtubeId: string; thumbnailUrl: string } => {
  const idMatch = youtubeLink.match(
    /(?:https?:\/\/)?(?:www\.)?youtube\.com\/watch\?v=([^&]+)|(?:https?:\/\/)?(?:www\.)?youtube\.com\/shorts\/([^?&]+)/
  );
  if (idMatch) {
    const id = idMatch[1] || idMatch[2]; // Get the matched id from either group
    const thumbnailUrl = `https://img.youtube.com/vi/${id}/hqdefault.jpg`;
    return { youtubeId: id, thumbnailUrl };
  }
  return { youtubeId: "", thumbnailUrl: "" };
};

export interface IPushRequestBody {
  title: string; // 알림 제목
  body: string; // 알림 내용
  tokenList: string[]; // FCM 토큰 목록
  data: Record<string, any>; // 추가 데이터 (키-값 쌍으로 된 객체)
}

const PUSH_NOTIFICATION_URL = process.env.REACT_APP_PUSH_NOTIFICATION_URL;

export type SendPushNotification = {
  successCount: number;
  failureCount: number;
  successfulTokenList: string[];
  failedTokenList: string[];
};

export const sendPushNotification = async (
  body: IPushRequestBody
): Promise<SendPushNotification> => {
  try {
    const response = await fetch(PUSH_NOTIFICATION_URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    });

    if (!response.ok) {
      throw new Error("Failed to send notification");
    }

    const responseData = await response.json();
    const successCount = responseData.successCount;
    const failureCount = responseData.failureCount;
    const failedTokenList = responseData.failedTokenList;
    const successfulTokenList = responseData.successfulTokenList;

    console.log("Notification sent successfully");
    console.log("response data: ", responseData);

    // 출력하려는 요소들
    console.log("successCount: ", successCount);
    console.log("failureCount: ", failureCount);
    console.log("failedTokenList: ", failedTokenList);
    console.log("successfulTokenList: ", successfulTokenList);

    const notificationLogCollection = collection(
      db,
      Collections.PUSH_NOTIFICATION_LOG
    );

    const now = new Date();
    const month = String(now.getMonth() + 1).padStart(2, "0");
    const day = String(now.getDate()).padStart(2, "0");
    const hours = String(now.getHours()).padStart(2, "0");
    const minutes = String(now.getMinutes()).padStart(2, "0");
    const seconds = String(now.getSeconds()).padStart(2, "0");

    // songId가 없으면 userId + MMDDHHSS 형식으로 ID 생성
    const generatedId = `${month}월${day}일${hours}:${minutes}:${seconds}`;

    const log: PushNotificationLog = {
      id: generatedId,
      successfulTokenList: successfulTokenList,
      failedTokenList: failedTokenList,
      pushAt: serverTimestamp(),
    };

    await setDoc(doc(notificationLogCollection, generatedId), log);
    if (failureCount > 0) {
      console.warn(
        `Failed to send notification to ${failureCount} tokens. Failed tokens: ${failedTokenList.join(
          ", "
        )}`
      );
      window.alert(
        `알림 전송에 실패했습니다. 실패한 토큰 갯수: ${failureCount}, 실패한 토큰: ${failedTokenList.join(
          ", "
        )}`
      );
    } else {
      window.alert(
        `알림이 성공적으로 전송되었습니다.\n\n` +
          `제목: ${body.title}\n` +
          `내용: ${body.body}\n\n` +
          `성공한 토큰 갯수: ${successCount}\n` +
          `성공한 토큰: ${successfulTokenList.join(", ")}`
      );
    }

    return {
      successCount,
      failureCount,
      successfulTokenList,
      failedTokenList,
    };
  } catch (error) {
    console.error("Error sending notification:", error);
    throw error;
  }
};
